import { configure, localize, extend } from 'vee-validate'
import * as rules from 'vee-validate/dist/rules'
import * as customRules from '@/services/validationRule'

configure({
  mode: 'eager',
  classes: {
    // valid: 'is-valid',
    invalid: 'is-invalid',
  },
  useConstraintAttrs: false,
})

// import all pre-defined rules
for (let rule in rules) {
  extend(rule, rules[rule])
}

// import all custom rules
for (let rule in customRules) {
  extend(rule, customRules[rule])
}

// has to be defined after rules
localize('cs', {
  messages: {
    required: 'Pole je povinné',
    required_if: 'Pole je povinné',
    email: 'Pole neobsahuje validní formát emailu',
    numeric: 'Zadejte kladné číslo',
    digits: (field, { length } = {}) => {
      let numbers = 'číslic'
      if (length === 1) numbers = 'číslici'
      else if (length < 5) numbers = 'číslice'

      return `Pole musí obsahovat právě ${length} ${numbers}`
    },
    min: (field, params) => `Pole musí obsahovat alespoň ${params.length} znaků`,
    max: (field, params) => `Pole musí obsahovat maximálně ${params.length} znaků`,
    min_value: (field, params) => `Pole musí být číslo větší než ${params.value}`,
    min_date: 'Pole musí být pozdější datum',
    min_date_iso: 'Pole musí být pozdější datum',
    max_date: 'Pole musí být dřívější datum',
    max_date_iso: 'Pole musí být dřívější datum',
    date_input_group: 'Pole neobsahují validní datum',
    oneOf: 'Pole neobsahuje hodnotu z nabídky',
    bool_question_required: 'Vyberte jednu z možností',
    birth_number: 'Pole neobsahuje validní formát rodného čísla',
    bank_account: 'Pole neobsahuje validní formát bankovního účtu',
    ispv_code: 'Vložte prosím zkopírovaný kód ISPV z Aplikace Obor vzdělání (link pod tímto polem)',
  },
})
